import { CanisterInfo } from '@plug-core/idls/topUp/topUp'
import { formatNumber } from '@plug-core/utils/formatNumber'
import { IconButton, Surface, Text, cn } from '@ui'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FaPen, FaTrash } from 'react-icons/fa6'

interface Props {
  canister: CanisterInfo
  onCanisterDelete: () => void
  onCanisterUpdate: () => void
}

const CanisterCard: FC<Props> = ({ canister, onCanisterDelete, onCanisterUpdate }) => {
  const { t } = useTranslation()

  return (
    <Surface
      key={canister.id.toString()}
      padding="none"
      className={cn(
        'mt-2 border-t-[6px]',
        canister.is_healthy ? 'border-t-success' : 'border-t-danger'
      )}
    >
      <div className="flex flex-col gap-2 px-4 pt-4 pb-2">
        <Text title={canister.name} tone="fg" weight="semibold" truncate>
          {canister.name}
        </Text>
        <Text variant="body-s" tone="fg-2" tabular>
          {canister.auto_topup
            ? t('topup.canisterCard.cyclesLeft', {
                cycles: formatNumber(Number(canister.cycles_left)),
              })
            : t('topup.canisterCard.autoTopupOff')}
        </Text>
      </div>
      <div className="flex justify-end gap-2 px-4 pb-3">
        <IconButton
          size="sm"
          className="text-accent"
          aria-label={t('topup.canisterCard.edit')}
          onClick={onCanisterUpdate}
        >
          <FaPen className="size-3.5" />
        </IconButton>
        <IconButton
          size="sm"
          className="text-danger"
          aria-label={t('topup.canisterCard.delete')}
          onClick={onCanisterDelete}
        >
          <FaTrash className="size-3.5" />
        </IconButton>
      </div>
    </Surface>
  )
}

export default CanisterCard
